import React from "react";

// Material UI
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

// Material UI Icons
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import useStyles, { Colortheme } from "../../pages/comman";

const DeleteModal = ({ isOpen, onDeleteEvent, onCloseEvent }: any) => {
  // Color for design
  const { cardBorder, cardbg, white } = Colortheme();
  const classes = useStyles();

  return (
    <React.Fragment>
      <Dialog open={isOpen} onClose={onCloseEvent}>
        <Box
          className={classes.cardCommam}
          sx={{ borderColor: cardBorder, backgroundColor: cardbg }}
        >
          <Box className={classes.cardbody}>
            <DialogTitle id="alert-dialog-title" sx={{ textAlign: "center" }}>
              <Box>
                <DeleteOutlineIcon color="error" sx={{ fontSize: "3.5rem" }} />
              </Box>
              <Box>{"Remove Contact ?"}</Box>
            </DialogTitle>
            <DialogContent sx={{ textAlign: "center" }}>
              <DialogContentText>
                Are you sure you want to delete this product ?
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="inherit"
                size="large"
                disableElevation
                onClick={onCloseEvent}
              >
                Close
              </Button>
              <Button
                variant="contained"
                color="error"
                sx={{ color: white }}
                size="large"
                disableElevation
                onClick={onDeleteEvent}
                autoFocus
              >
                Yes, Delete It!
              </Button>
            </DialogActions>
          </Box>
        </Box>
      </Dialog>
    </React.Fragment>
  );
};

export default DeleteModal;
